import { MB } from '@wetransfer/transfer/constant/sizes';

// TODO: replace with translated string and proper error notification before global release
export const GENERIC_ERROR_MESSAGE =
  'Hmm, something went wrong - please try again or contact us through our help center';

export const INVALID_FILE_ERROR_MESSAGE =
  'This file is too big, or not a png or jpg format - try a different image';

export const MAX_UPLOAD_FILE_SIZE_MB = 5;

export const MAX_UPLOAD_FILE_SIZE = MAX_UPLOAD_FILE_SIZE_MB * MB;

export const UPLOAD_FILE_NAME_REGEX = /.(jp(e?)g|png)$/i;

export const MIN_WALLPAPER_WIDTH = 1920;

export const MIN_WALLPAPER_HEIGHT = 1200;
